import axios, { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import { baseUrl } from '../constatnts/Connections';
import { ForgotPassword, ResetPassword } from '../model/userDto';

interface LoginDto {
    email: string;
    password: string;
}
interface SingUp {
    username: string;
    email: string;
    password: string;
}
export function handleError(error: any) {
    return { status: error?.response?.status, data: error?.response?.data };
}
export function handleSuccess(response: any) {
    const data = !!response.data ? response.data : response.data;
    const responseData = isJson(data) ? JSON.parse(data) : data;
    return { status: response.status, data: responseData };
}
export const isJson = (str: any) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};
export async function login(user: LoginDto) {
    console.log('read', user);
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/user/signin`,
        data: user,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function singUp(user: SingUp) {
    console.log('read', user);
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/user/signup`,
        data: user,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function whoAmI() {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/user/whoami`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function verifyUserAccount(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/user/verify/email`,
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function forgotPassword(user: ForgotPassword) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/user/forgot-password`,
        data: user,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function resetPassword(user: ResetPassword) {
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/user/reset-password`,
        data: user,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function changePassword(password: string) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/user/change/password`,
        data: { password },
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getUsers(limit = 0, offset = 0, text = '', subscription = '', valid: any = '') {
    const token = localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        url: `${baseUrl}/user/search?limit=${limit}&offset=${offset}&text=${text}&subscription=${subscription}&valid=${valid}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getSubscriptionCatalog() {
    const token = localStorage.getItem('accessToken');
    const options = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/user/catalog`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getSingleUserById(id: string) {
    const token = localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        url: `${baseUrl}/user/single/${id}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function createUserSubsciption(data: any) {
    const token = localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/user/user-subscription`,
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function updateUser(data: any) {
    const token = localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/user/update`,
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function deleteUser(id: string) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'DELETE',
        url: `${baseUrl}/user/delete/${id}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function softDeleteUser(id: string) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'DELETE',
        url: `${baseUrl}/user/soft-delete/${id}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function createFinanceCard(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/user/finance-card`,
        data: data,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function deleteLastFinanceCard(id: string) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'DELETE',
        url: `${baseUrl}/user/remove-last-finance-card/${id}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function exportKvizPitanjaExcel(
    text = '',
    isLekcijaPitanje: any = '',
    isKvizPitanje: any = '',
    visible: any = '',
    tags: string[] = [],
    zaPraksu: any = '',
    zaTakmicenje: any = '',
    ids: string[] = [],
    tezine: string[] = [],
    oblastId = '',
) {
    const token = localStorage.getItem('accessToken');
    let query = '';
    const push = (k: string, v: string) => {
        query += (query ? '&' : '') + `${k}=${encodeURIComponent(v)}`;
    };
    if (text) push('text', text);
    tags.forEach((tag) => push('tags', tag));
    if (isLekcijaPitanje !== '') push('isLekcijaPitanje', isLekcijaPitanje);
    if (isKvizPitanje !== '') push('isKvizPitanje', isKvizPitanje);
    if (visible !== '') push('visible', visible);
    if (zaPraksu !== '') push('zaPraksu', zaPraksu);
    if (zaTakmicenje !== '') push('zaTakmicenje', zaTakmicenje);
    ids.forEach((id) => push('ids', id));
    tezine.forEach((t) => push('tezine', t));
    if (oblastId) push('oblastId', oblastId);

    const options: AxiosRequestConfig = {
        method: 'GET',
        url: `${baseUrl}/kviz-pitanja/export-excel?${query}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
    };

    return axios(options);
}

export async function getKvizPitanjaSearch(
    limit = 0,
    offset = 0,
    text = '',
    isLekcijaPitanje: any = '',
    isKvizPitanje: any = '',
    visible: any = '',
    tags: string[] = [],
    zaPraksu: any = '',
    zaTakmicenje: any = '',
    tezine: string[] = [],
    oblastId = '',
) {
    const token = localStorage.getItem('accessToken');
    console.log('getKvizPitanjaSearch', { limit, offset, text, isLekcijaPitanje, isKvizPitanje, visible, tags, zaPraksu, zaTakmicenje });
    // Konstruisanje query stringa ručno
    let query = `limit=${limit}&offset=${offset}`;

    if (text) query += `&text=${encodeURIComponent(text)}`;
    if (tags.length > 0) {
        tags.forEach((tag) => {
            query += `&tags=${encodeURIComponent(tag)}`;
        });
    }
    tezine.forEach((t) => {
        query += `&tezine=${encodeURIComponent(t)}`;
    });
    if (oblastId) query += `&oblastId=${encodeURIComponent(oblastId)}`;
    if (isLekcijaPitanje !== '') query += `&isLekcijaPitanje=${isLekcijaPitanje}`;
    if (isKvizPitanje !== '') query += `&isKvizPitanje=${isKvizPitanje}`;
    if (visible !== '') query += `&visible=${visible}`;
    if (zaPraksu !== '') query += `&zaPraksu=${zaPraksu}`;
    if (zaTakmicenje !== '') query += `&zaTakmicenje=${zaTakmicenje}`;

    const options: AxiosRequestConfig = {
        method: 'GET',
        url: `${baseUrl}/search/kviz-pitanja?${query}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function sendContactMessage(data: { name: string; email: string; message: string; website?: string }) {
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/contact`,
        data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
